/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Note = props => (
  <svg viewBox="0 0 44 44" fill="none" width="1em" height="1em" {...props}>
    <path
      d="M17.414 6.528H8.71a2.174 2.174 0 00-2.176 2.176v26.112c0 1.204.973 2.176 2.176 2.176h10.282l-.36 2.176H8.71a4.356 4.356 0 01-4.352-4.352V8.704c0-2.4 1.952-4.352 4.352-4.352h9.078c1.156 0 2.265.456 3.08 1.272l8.324 8.336a4.353 4.353 0 011.272 3.08v4.455l-2.176 2.176v-6.256H21.76a4.356 4.356 0 01-4.352-4.352V6.535l.006-.007zm9.976 8.704l-7.8-7.8v5.624c0 1.204.973 2.176 2.176 2.176h5.624zm-2.013 19.033c-.32.32-.53.735-.605 1.177l-.578 3.447 3.448-.578a2.16 2.16 0 001.176-.605l6.943-6.943-3.448-3.447-6.943 6.942.007.007zm8.473-8.48l3.448 3.448 1.407-1.407a2.438 2.438 0 00-3.447-3.448l-1.408 1.408zm-11.227 9.303c.15-.89.571-1.72 1.217-2.36l9.88-9.88a4.609 4.609 0 016.522 0 4.609 4.609 0 010 6.521l-9.887 9.88a4.372 4.372 0 01-2.36 1.218l-5.066.843a1.018 1.018 0 01-1.156-1.156l.85-5.066z"
    />
  </svg>
);
export default extendIcon(Note);

